"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PUSHTypes_1 = require("../PUSHTypes");
const PUSHClient_1 = __importDefault(require("../PUSHClient"));
const GetRefreshPeriod_1 = require("./calls/GetRefreshPeriod");
const SetRefreshPeriod_1 = require("./calls/SetRefreshPeriod");
const SubscribeAsynchronousResponse_1 = require("./calls/SubscribeAsynchronousResponse");
class AAPIClient extends PUSHClient_1.default {
    constructor(params) {
        super(params);
        this._regexArrayLocal = [
            { regex: /(\d{1,4})\/D\S60.*$/, method: this._onSetRefreshPeriod },
            {
                regex: /(\d{1,4})\/D\S61.*$/,
                method: this._onGetRefreshPeriod,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'refreshPeriodMS',
                },
            },
        ];
        this.getRefreshPeriod = GetRefreshPeriod_1.getRefreshPeriod.bind(this);
        this.setRefreshPeriod = SetRefreshPeriod_1.setRefreshPeriod.bind(this);
        this.subscribeAsynchronousResponse = SubscribeAsynchronousResponse_1.subscribeAsynchronousResponse.bind(this);
        this.extendRegex(this._regexArrayLocal);
    }
    _onSetRefreshPeriod({ bodyObject }) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        const correlationData = this._correlationData[correlationId];
        super.removeFromPushMessages(correlationId);
        if (returnCode === 0) {
            correlationData.callbackOnSuccess({});
        }
        else {
            correlationData.callbackOnException(new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onGetRefreshPeriod({ bodyObject }) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        const refreshPeriodMS = Number(bodyObject.refreshPeriodMS);
        const correlationData = this._correlationData[correlationId];
        super.removeFromPushMessages(correlationId);
        if (returnCode === 0) {
            const response = {
                refreshPeriodMS,
            };
            correlationData.callbackOnSuccess(response);
        }
        else {
            correlationData.callbackOnException(new PUSHTypes_1.AsyncException({
                returnCode: returnCode,
            }));
        }
    }
}
exports.default = AAPIClient;
